module.exports = __webpack_public_path__ + "img/47.5d1a9869.jpg";